import type { BlogArticle } from "@/types/blog"

export const blogArticles: BlogArticle[] = [
  {
    id: "blog-1",
    slug: "yak-pravylno-sterylizuvaty-banky",
    title: "Як правильно стерилізувати банки: простий і безпечний підхід",
    excerpt:
      "Пояснюємо, як підготувати банки до домашніх заготовок без зайвого стресу, типових помилок і небезпечних дрібниць.",
    description:
      "Практичний гайд для тих, хто хоче стерилізувати банки правильно, без хаосу і зайвих маніпуляцій.",
    image: "/images/blog/sterilizing-jars.jpg",
    category: "guides",
    tags: ["стерилізація", "банки", "безпека", "для початківців"],
    publishedAt: "2026-03-10",
    updatedAt: "2026-03-12",
    authorName: "Кухлик",
    readingTimeMinutes: 6,
    featured: true,
    sections: [
      {
        title: "Навіщо взагалі стерилізувати банки",
        paragraphs: [
          "Стерилізація потрібна для того, щоб знизити ризик псування заготовок і прибрати мікроорганізми, які можуть зіпсувати продукт ще до того, як банку поставлять у комору.",
          "Особливо важливо не пропускати цей етап, якщо ви робите консервацію для тривалого зберігання при кімнатній температурі.",
        ],
      },
      {
        title: "Що перевірити перед початком",
        paragraphs: [
          "Перед стерилізацією банки потрібно добре вимити, перевірити на тріщини, сколи й пошкодження різьби або горлечка.",
          "Кришки теж повинні бути чистими, без деформацій і слідів іржі.",
        ],
        list: [
          "переконайтеся, що банка не має тріщин",
          "використовуйте чисту губку і нейтральний миючий засіб",
          "після миття добре сполосніть тару",
        ],
      },
      {
        title: "Основні способи стерилізації",
        paragraphs: [
          "Найпоширеніші варіанти — пар, духовка або кип’ятіння. Вибирайте той спосіб, який вам простіше контролювати на своїй кухні.",
          "Для багатьох домашніх сценаріїв найзручніше працює духовка або пар над каструлею.",
        ],
        list: [
          "на парі — добре для невеликої кількості банок",
          "у духовці — зручно для партії банок одного розміру",
          "кип’ятіння — класичний, але не завжди найзручніший варіант",
        ],
      },
      {
        title: "Типові помилки",
        paragraphs: [
          "Часто проблема не в самому способі стерилізації, а в дрібницях: банки ставлять на брудну поверхню, не досушують, торкаються внутрішньої частини руками або затягують кришки на перекіс.",
          "Важливо не тільки стерилізувати банки, а й не зруйнувати чистоту вже після підготовки.",
        ],
      },
    ],
  },
  {
    id: "blog-2",
    slug: "chomu-mutniye-rassil-u-bankakh",
    title: "Чому мутніє розсіл у банках і коли це вже небезпечно",
    excerpt:
      "Розбираємо типові причини помутніння, різницю між нормальним процесом і реально небезпечними сигналами.",
    description:
      "Практичний матеріал про те, чому мутніє розсіл у консервації і як правильно оцінювати ризики.",
    image: "/images/blog/cloudy-brine.jpg",
    category: "safety",
    tags: ["розсіл", "безпека", "помилки консервації"],
    publishedAt: "2026-03-09",
    updatedAt: "2026-03-12",
    authorName: "Кухлик",
    readingTimeMinutes: 7,
    featured: true,
    sections: [
      {
        title: "Помутніння буває різним",
        paragraphs: [
          "Не кожне помутніння означає, що банку потрібно негайно викидати. У ферментації легка мутність може бути частиною нормального процесу.",
          "Але для класичних маринадів на тривале зберігання це вже більш тривожний сигнал.",
        ],
      },
      {
        title: "Найчастіші причини",
        paragraphs: [
          "Проблема може бути пов’язана з поганою стерилізацією, неякісною водою, помилками в пропорціях або забрудненням інгредієнтів.",
          "Іноді мутність з’являється через дрібний осад спецій, але це треба вміти відрізняти від небезпечного бродіння.",
        ],
        list: [
          "порушення стерильності",
          "занадто слабкий маринад",
          "брудні овочі або зелень",
          "неправильне зберігання",
        ],
      },
      {
        title: "Коли банку краще не вживати",
        paragraphs: [
          "Якщо разом із мутністю з’явилися газоутворення, неприємний запах, здута кришка або підозрілий колір — таку заготовку краще не їсти.",
          "У питаннях консервації безпека завжди важливіша за спробу врятувати одну банку.",
        ],
      },
    ],
  },
  {
    id: "blog-3",
    slug: "fermentaciya-dlya-pochatkivciv",
    title: "Ферментація для початківців: що важливо зрозуміти до першої банки",
    excerpt:
      "Просте пояснення принципів ферментації: сіль, середовище, температура, безпека і типові стартові помилки.",
    description:
      "Базовий стартовий матеріал для тих, хто хоче розібратися з ферментацією без містики і хаосу.",
    image: "/images/blog/fermentation-basics.jpg",
    category: "fermentation",
    tags: ["ферментація", "без оцту", "здорове харчування"],
    publishedAt: "2026-03-08",
    updatedAt: "2026-03-12",
    authorName: "Кухлик",
    readingTimeMinutes: 8,
    featured: true,
    sections: [
      {
        title: "Чим ферментація відрізняється від маринування",
        paragraphs: [
          "У маринуванні кислотність створюється зовнішньо — за рахунок оцту або іншої кислоти. У ферментації середовище змінюється поступово внаслідок природних процесів.",
          "Саме тому тут особливо важливі пропорції солі, чистота і контроль умов.",
        ],
      },
      {
        title: "Що найважливіше на старті",
        paragraphs: [
          "Новачкам не потрібно одразу брати складні рецепти. Краще почати з простих овочів і чітко контрольованих пропорцій.",
          "Ферментація любить акуратність і спокій, а не експерименти навмання.",
        ],
        list: [
          "використовуйте ваги",
          "не зменшуйте сіль без розуміння наслідків",
          "слідкуйте, щоб продукт був покритий розсолом",
          "не використовуйте випадковий металевий посуд",
        ],
      },
      {
        title: "Типові помилки",
        paragraphs: [
          "Найчастіше новачки недооцінюють роль солі, беруть занадто тепле місце або відкривають ємність занадто часто.",
          "Ще одна поширена помилка — змішувати логіку ферментації з логікою звичайних маринадів.",
        ],
      },
    ],
  },
  {
    id: "blog-4",
    slug: "shcho-robyty-z-velykym-urozhayem-kabachkiv",
    title: "Що робити з великим урожаєм кабачків: стратегія без паніки",
    excerpt:
      "Як не потонути в сезоні кабачків: розподілити урожай між свіжими стравами, заморожуванням і заготовками.",
    description:
      "Практичний сезонний матеріал про те, як розумно використати великий урожай кабачків.",
    image: "/images/blog/zucchini-season.jpg",
    category: "seasonal",
    tags: ["кабачки", "сезон", "урожай", "планування"],
    publishedAt: "2026-03-07",
    updatedAt: "2026-03-12",
    authorName: "Кухлик",
    readingTimeMinutes: 5,
    featured: true,
    sections: [
      {
        title: "Спочатку — план, а не хаос",
        paragraphs: [
          "Найгірший сценарій у сезоні — намагатися використати все відразу без плану. Частину продукту краще залишити на поточну кухню, частину пустити в заготовки, а частину заморозити.",
          "Такий підхід зменшує втому і допомагає не робити випадкові рецепти просто з відчаю.",
        ],
      },
      {
        title: "Як розподілити урожай",
        paragraphs: [
          "Зручно спочатку оцінити обсяг: що реально можна з’їсти швидко, що варто переробити в салати, а що краще піде в ікру, маринади або заморозку.",
          "Коли є план, легше вибрати правильні рецепти і розрахувати потрібні банки.",
        ],
      },
    ],
  },
]

export function getAllBlogArticles() {
  return blogArticles
}

export function getFeaturedBlogArticles() {
  return blogArticles.filter((article) => article.featured)
}

export function getBlogArticleBySlug(slug: string) {
  return blogArticles.find((article) => article.slug === slug)
}